<template>
    <div class="container circle_nav d-flex">
      <div class="left d-flex">
        <div class="circle">
          <a href="https://member.top-link.com.tw/#/card" target="_blank">
            <img class="circle_img" src="../../assets/circle/5a.png" alt="活動查詢"><img class="circle_img_hover" src="../../assets/circle/5b.png" alt="">
          </a>
        </div>
        <div class="circle">
          <router-link to="schedule"> 
            <img class="circle_img" src="../../assets/circle/6a.png" alt="年度檔期"><img class="circle_img_hover" src="../../assets/circle/6b.png" alt="">
          </router-link>
        </div>
      </div>

      <div class="right d-flex">
        <div class="circle">
          <router-link to="about"> 
            <img class="circle_img" src="../../assets/circle/4a.png" alt="公司簡介"><img class="circle_img_hover" src="../../assets/circle/4b.png" alt="">
          </router-link> 
        </div>
        <div class="circle">
          <a href="https://www.top-link.com.tw/news/307" target="_blank">
            <img class="circle_img" src="../../assets/circle/7a.png" alt="會員專屬活動"><img class="circle_img_hover" src="../../assets/circle/7b.png" alt="">
          </a>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      circle_nav:[
        // {name:'廠商專區',id:"https://partner.top-link.com.tw/en" ,img:require('../../assets/1b.png')},
        // {name:'加入會員',id:"https://member.top-link.com.tw/#/singup/index" ,img:require('../../assets/1b.png')},
        // {name:'報名查詢',id:"https://member.top-link.com.tw/#/record/checkin" ,img:require('../../assets/1b.png')},
        // {name:'得獎名單',id:"https://www.top-link.com.tw/tlweb/winner?history=0" ,img:require('../../assets/1b.png')},
      ]
    }
  },
}
</script>

<style>
   .circle_nav{
     margin: 20px auto 0 ;
     justify-content: center;
     flex-wrap:wrap;
   }
   .circle{
     /* position: relative; */
     vertical-align: middle;

   }
   .circle a{
     position: relative;
     display: inline-block;
     width: 100%;
     height: 100%;
   }
   .left{
      /* width: 50%; */
      justify-content:center;
    }
    .right{
      /* width: 50%; */
    }
   .circle_img_hover{

     position: absolute;
     top:0;
     left: 50%;
     transform: translateX(-50%);
     opacity: 0;
     transition: all .5s;
   }
   .circle a img{
    width: 85%;
    display: block;
    margin: auto;
   }
   .circle:hover .circle_img_hover{
     opacity: 1;
   }
   @media (max-width: 768px){
     .circle_nav{
       margin: 0px auto 0 ;
     }
    .circle{
      transform: scale(.85);
      width: 50%;
      height: 100%;
      /* justify-content:space-around; */
    }
    .circle a img{
     width: 100%;
    }
    .left{
      width: 100%;
    }
    .right{
      width: 100%;
    }
   }
</style>

